import React, { useCallback, useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
// import 'dropzone/dist/dropzone.css'; // Import Dropzone CSS
import Icon from '../../../YourAIAgents/components/components/icon';

const MyDropzone = ({ gettingfilefromdropzone, setLoader, loader }) => {
  const [files, setFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  // const [loader, setLoader] = useState(false);
  const [firstscreen, setFirstscreen] = useState(false);
  const [audioFileChecks, setAudioFileChecks] = useState({});
  const [uploading, setUploading] = useState(false)
  // const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB in bytes

  const allowedTypes = [
    // Images
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",

    // Text & markup
    "text/plain",
    "text/markdown",
    "text/html",
    "text/css",
    "application/xml",

    // Code & data
    "application/json",
    "application/javascript",
    "application/typescript",
    "application/x-sh",
    "application/x-httpd-php",
    "application/x-tex",

    // Programming languages
    "text/x-python",
    "text/x-java-source",
    "text/x-c",
    "text/x-c++src",
    "text/x-csharp",
    "application/x-ruby",

    // Documents
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.oasis.opendocument.text",
    "application/rtf",

    // Presentations
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",

    // Spreadsheets
    "text/csv",
    "text/tab-separated-values",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

    // Audio
    "audio/mpeg",
    "audio/mpga",
    "audio/wav",
    "audio/mp4",
    "audio/x-m4a",
    "audio/flac",

    // Video
    "video/mp4",
    "video/mpeg",
    "video/webm"
  ];

  const audiofilestype = [
    "audio/mpeg",   // mp3
    "audio/mpga",   // mpga
    "audio/wav",    // wav
    "audio/mp4",    // m4a
    "audio/x-m4a",  // m4a
    "audio/flac",   // flac

    // if treating video as playable media
    "video/mp4",
    "video/mpeg",
    "video/webm"
  ];

  useEffect(() => {
    const storedFiles = localStorage.getItem('uploadedFiles');
    if (storedFiles) {
      setFiles(JSON.parse(storedFiles));
    }
  }, []);

  const saveFilesToStorage = updatedFiles => {
    localStorage.setItem('uploadedFiles', JSON.stringify(updatedFiles));
    if (!uploading) {
      setLoader(false);
    }
  };

  const onDrop = useCallback(acceptedFiles => {
    const validFiles = acceptedFiles;
    let errorMessages = '';

    // Check for invalid file types
    if (validFiles.length !== acceptedFiles.length) {
      const invalidFiles = acceptedFiles.filter(file => !allowedTypes.includes(file.type));
      const invalidFileNames = invalidFiles.map(file => file.name).join(', ');
      if (invalidFileNames) {
        errorMessages += `<p style="color:red;">Only specific file types are allowed. Invalid files: <br></br>${invalidFileNames}</p>`;
      }
    }

    // Set the error message if any errors occurred
    if (errorMessages !== '') {
      setErrorMessage(errorMessages);
      return; // Stop processing further if any errors occurred
    }

    // Set uploading to true when starting process
    setUploading(true);
    setLoader(true);

    // Proceed with valid files
    const updatedFiles = validFiles.map(file => ({
      file,
      progress: 0,
      completed: false
    }));

    setFiles([...files, ...updatedFiles]);

    if (errorMessage !== '') {
      setErrorMessage('');
      setFirstscreen(true);
    } else {
      setFirstscreen(true);
    }

    // Progress simulation
    const interval = setInterval(() => {
      setFiles(prevFiles => {
        const newFiles = prevFiles.map(prevFile => {
          const updatedFile = updatedFiles.find(file => file.file === prevFile.file);
          if (updatedFile) {
            if (prevFile.progress < 100) {
              setFirstscreen(true);
              return {
                ...prevFile,
                progress: prevFile.progress + 10
              };
            } else if (prevFile.progress >= 100) {
              return {
                ...prevFile,
                progress: 100,
                completed: true
              };
            }
          }
          return prevFile;
        });

        // Check if all updated files are complete
        const allComplete = updatedFiles.every(upFile => {
          const matchingFile = newFiles.find(f => f.file === upFile.file);
          return matchingFile && matchingFile.completed;
        });

        if (allComplete) {
          clearInterval(interval);
          setUploading(false);
          saveFilesToStorage(newFiles);
        }

        return newFiles;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [files, errorMessage]);


  const handlesave = e => {
    e.preventDefault();
    const filesWithCheckboxes = files.map(file => ({
      ...file,
      isChecked: audioFileChecks[file.file.name] || true
    }));
    gettingfilefromdropzone(filesWithCheckboxes);
    setLoader(true);
    localStorage.removeItem('uploadedFiles');
  };

  const handleDelete = fileToDelete => {
    const updatedFiles = files.filter(file => file.file !== fileToDelete);
    setFiles(updatedFiles);
    saveFilesToStorage(updatedFiles);
    if (updatedFiles.length < 1) {
      setFirstscreen(false);
    }
  };

  const handleCheckboxChange = (fileName, isChecked) => {
    setAudioFileChecks({
      ...audioFileChecks,
      [fileName]: isChecked
    });
  };

  const restart = () => {
    setFiles([]);
    saveFilesToStorage([]);
    setFirstscreen(false);
    setUploading(false);
  };

  return (
    <div className='maindiv'>
      <Dropzone onDrop={onDrop} accept={allowedTypes.join(',')}>
        {({ getRootProps, getInputProps }) => (
          <>
            {firstscreen === false && <div {...getRootProps()} className="dropzone">
              <input {...getInputProps()} />
              {files.length <= 0 && (
                <div className="text-center" id="removetext">
                  <p>Drag & drop files here, or click to select files</p>
                  <button className="uploadbutton">Upload Files</button>
                </div>
              )}
              {errorMessage && (
                <div className="error-message text-center">
                  <div dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
                </div>
              )}
            </div>}
          </>
        )}
      </Dropzone>
      <div className="text-right position-absolute" style={{ top: 0, right: "72px" }}>
        {files.length > 0 && (
          <>
            <button onClick={restart} className="px-2 mx-2 cancelbutton">
              Cancel
            </button>
            {loader ? <button className="uploadbutton">
              wait...
            </button>
              : <button onClick={handlesave} className="uploadbutton">
                Continue
              </button>}
          </>
        )}
      </div>
      <div className="file-list">
        {files.map((uploadedFile, index) => (
          <div key={index} className="file-item">
            <p className="ellipsetext">{uploadedFile.file.name}</p>
            <div className='deleterow'>
              <p style={{ margin: "10px 0px" }}>{parseFloat(uploadedFile.file.size / (1024 * 1024)).toFixed(2)} MB</p>
              <p className='px-2' onClick={() => handleDelete(uploadedFile.file)}> {uploadedFile.completed && <Icon id="delete" />}</p>
            </div>
            {!uploadedFile.completed && (
              <progress className="progress-z" value={uploadedFile.progress} max="100" />
            )}
            {uploadedFile.completed && (
              <p className="success-message"></p>
            )}
            {!uploadedFile.completed && <button onClick={() => handleDelete(uploadedFile.file)} className="crossicon-z delete-button">
              X
            </button>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyDropzone;
